(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cajita-configurador"]) return;
  try {
    

(() => {
function init(root){
 const t=JSON.parse(root.querySelector('[data-cajita-labels]').textContent);
 if(root.dataset.ready)return;root.dataset.ready='true';
 const form=root.querySelector('form'),total=root.querySelector('[data-total]'),error=root.querySelector('[data-error]'),options=[...root.querySelectorAll('[name="items"]')],list=root.querySelector('[data-selection]'),personalization=root.querySelector('[data-personalization]');
 let busy=false,step=0;
 const panels=[...root.querySelectorAll('[data-step-panel]')],stepNav=root.querySelector('.cajita-configurator__steps'),navigation=root.querySelector('.cajita-configurator__navigation'),back=root.querySelector('[data-back]'),next=root.querySelector('[data-next]'),submit=form.querySelector('[type=submit]');
 form.noValidate=true;
 const showStep=(value,focus=true)=>{step=value;panels.forEach((panel,index)=>panel.hidden=index!==step);root.querySelectorAll('.cajita-configurator__steps [data-step-link]').forEach(button=>{if(Number(button.dataset.stepLink)===step)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');});back.hidden=step===0;next.hidden=step===2;submit.hidden=step!==2;if(focus)panels[step].focus();};
 const validateStep=value=>{error.hidden=true;if(value===0&&!options.some(option=>option.checked)){showStep(0,false);error.textContent=t.chooseItem;error.hidden=false;options[0].focus();return false;}const invalid=[...panels[value].querySelectorAll('input,select,textarea')].find(field=>!field.disabled&&!field.checkValidity());if(invalid){showStep(value,false);error.textContent=t.complete;error.hidden=false;invalid.focus();invalid.reportValidity();return false;}return true;};
 options.forEach(option=>{
  const card=option.closest('label'),details=document.createElement('div');details.className='cajita-configurator__item-detail';details.hidden=true;
  const quantityLabel=document.createElement('label');quantityLabel.textContent=t.quantityOf+option.dataset.title;
  const quantity=document.createElement('input');quantity.type='number';quantity.name='quantity_'+option.value;quantity.min='1';quantity.max='10';quantity.step='1';quantity.value='1';quantity.disabled=true;quantityLabel.append(quantity);
  const nameLabel=document.createElement('label');nameLabel.textContent=t.articleName;
  const name=document.createElement('input');name.name='name_'+option.value;name.maxLength=50;name.placeholder=t.sameName;name.disabled=true;nameLabel.append(name);
  const noteLabel=document.createElement('label');noteLabel.textContent=t.articleNote;
  const note=document.createElement('textarea');note.name='notes_'+option.value;note.maxLength=250;note.placeholder=t.articleExample;note.disabled=true;noteLabel.append(note);
  const help=document.createElement('small');help.textContent=t.differentUnits;
  const quantities=document.createElement('div');quantities.className='cajita-configurator__item-detail';quantities.hidden=true;quantities.append(quantityLabel);card.after(quantities);option.chQuantity=quantities;
  const heading=document.createElement('h3');heading.textContent=option.dataset.title;details.append(heading,nameLabel,noteLabel,help);panels[1].append(details);option.chDetails=details;
 });
 const refresh=()=>{
  root.querySelectorAll('[data-size-for],[data-details-for]').forEach(group=>{const id=group.dataset.sizeFor||group.dataset.detailsFor,enabled=options.some(option=>option.value===id&&option.checked);group.hidden=!enabled;group.disabled=!enabled;});
  let cents=0;list.replaceChildren();
  options.forEach(option=>{
   option.chQuantity.hidden=!option.checked;option.chQuantity.querySelector('input').disabled=!option.checked;
   option.chDetails.hidden=!option.checked;option.chDetails.querySelectorAll('input,textarea').forEach(e=>e.disabled=!option.checked);
   if(!option.checked)return;
   const quantity=Number(form.elements['quantity_'+option.value].value)||1;
   cents+=Math.round(Number(option.dataset.price)*100)*quantity;
   const li=document.createElement('li'),size=form.querySelector('[name="size_'+option.value+'"]:checked'),custom=form.elements['name_'+option.value].value.trim(),note=form.elements['notes_'+option.value].value.trim();
   const trim=option.value==='50224076292435'?form.elements.bib_trim.value:'';
   li.textContent=quantity+' × '+option.dataset.title+(size?' · '+size.value:'')+(trim?' · '+root.querySelector('[data-details-for] legend').textContent+': '+trim:'')+(custom?' · '+custom:'')+(note?' · '+note:'');list.append(li);
  });
  if(!list.children.length){const li=document.createElement('li');li.textContent=t.boxEmpty;list.append(li);}
  total.textContent=(cents/100).toLocaleString('es-ES',{style:'currency',currency:'EUR'});
  const data=new FormData(form);personalization.textContent=['Nombre: '+(data.get('name')||'—'),'Inicial: '+(data.get('initial')||'—'),'Color de la personalización: '+(data.get('color')||'—'),'Idea: '+(data.get('theme')||'—'),data.get('notes')||''].filter(Boolean).join(' · ');
 };
 form.addEventListener('input',refresh);form.addEventListener('change',refresh);
 root.querySelectorAll('[data-step-link]').forEach(button=>button.addEventListener('click',()=>{const target=Number(button.dataset.stepLink);if(target>step){for(let index=0;index<target;index++){if(!validateStep(index)){showStep(index,false);return;}}}showStep(target);}));
 next.addEventListener('click',()=>{if(validateStep(step))showStep(step+1);});back.addEventListener('click',()=>showStep(step-1));
 form.addEventListener('submit',async event=>{
  event.preventDefault();if(busy)return;
  if(step<2){if(validateStep(step))showStep(step+1);return;}
  for(let index=0;index<2;index++){showStep(index,false);if(!validateStep(index))return;}showStep(2,false);
  const selected=options.filter(option=>option.checked);
  error.hidden=true;
  if(!selected.length){error.textContent=t.chooseItem;error.hidden=false;options[0].focus();return;}
  const empty=[...form.querySelectorAll('[required]')].find(e=>!e.matches(':disabled')&&!e.matches('[type=radio]')&&!e.value.trim());
  if(empty){error.textContent=t.complete;error.hidden=false;empty.focus();return;}
  if(!form.reportValidity())return;
  const data=new FormData(form),group=window.crypto?.randomUUID?.()||String(Date.now()),properties={Cajita:'Bebé personalizada a tu gusto',Nombre:data.get('name').trim(),Inicial:data.get('initial').trim(),'Color de la personalización':data.get('color'),'Temática o idea':data.get('theme').trim(),_cajita_grupo:group};
  if(data.get('notes').trim())properties.Observaciones=data.get('notes').trim();
  const items=selected.map(option=>{
   const itemProperties={...properties},size=data.get('size_'+option.value),name=data.get('name_'+option.value).trim(),note=data.get('notes_'+option.value).trim();
   if(size)itemProperties.Talla=size;
   if(option.value==='50224076292435')itemProperties.Ribete=data.get('bib_trim');
   if(name)itemProperties['Nombre o inicial de este artículo']=name;
   if(note)itemProperties['Indicaciones de este artículo']=note;
   return{id:Number(option.value),quantity:Number(data.get('quantity_'+option.value)),properties:itemProperties};
  });
  const button=form.querySelector('[type=submit]');busy=true;button.disabled=true;button.textContent=t.adding;
  try{
   const base=window.Shopify?.routes?.root||'/',response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})}),result=await response.json();
   if(!response.ok)throw new Error(typeof result.description==='string'?result.description:t.addError);
   window.location.assign(base+'cart');
  }catch(cause){error.textContent=(cause.message||t.connectionError)+t.checkCart;error.hidden=false;}
  finally{busy=false;button.disabled=false;button.textContent=t.addBox;}
 });
 refresh();
 stepNav.hidden=false;navigation.hidden=false;showStep(0,false);
}
document.querySelectorAll('.cajita-configurator').forEach(init);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.cajita-configurator').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
